import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de connexion Keycloak (username + password).
 * Factory mémoïsée au niveau composant — jamais d'instance exportée.
 */
export const createKeycloakLoginSchema = () =>
  z.object({
    username: z.string().trim().min(1, { message: t("requiredFieldError") }),
    password: z.string().min(1, { message: t("passwordRequiredError") }),
  });

export type KeycloakLoginFormValues = z.infer<
  ReturnType<typeof createKeycloakLoginSchema>
>;
